export default "__VITE_ASSET__CLG_RfKY__"